import React from 'react';

import { useBraze } from 'app/shared/utils/useBraze';

function withBraze(
  PassedComponent: React.ComponentType<React.PropsWithChildren<any>>
) {
  const WrappedComponent = (props: any) => {
    useBraze();
    return <PassedComponent {...props} />;
  };

  return WrappedComponent;
}

export default withBraze;
